import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, HostListener } from '@angular/core';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, getStringDate } from 'src/app/common/util';
import { PurchaseOrderDetailResponse, PurchaseOrderResponse, ReportPurchaseOrderDatesWeeks, ReportPurchaseOrderDays } from 'src/app/models/purchase-order.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { OrderService } from 'src/app/services/order.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import esLocale from '@fullcalendar/core/locales/es-us';

interface OrderCalendar {
  title: string;
  startDate: string;
  extendedProps: ReportPurchaseOrderDays;
}
@Component({
  selector: 'app-order-purchase-calendar-report',
  templateUrl: './order-purchase-calendar-report.component.html',
  styleUrls: ['./order-purchase-calendar-report.component.scss']
})
export class OrderPurchaseCalendarReportComponent implements OnInit {
  @ViewChild('extraColumn') extraColumn!: ElementRef;
  filterOrders: OrderCalendar[] = []
  weeksData: { start: Date; end: Date; label: string }[] = [];
  maxEvents = 2;

  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth', // Vista inicial: mes
    locale: esLocale,
    headerToolbar: {
      left: '',
      center: 'title',
      right: 'today prev,next'
    },
    fixedWeekCount: false,
    events: this.filterOrders,
    editable: false,   // mover eventos
    dayMaxEvents: this.maxEvents, // Mostrar mínimo 2 eventos antes de "+ more"
    eventClick: this.handleEventClick.bind(this),
    datesSet: (info) => {
      this.generateWeeks(info.start, info.end);
    },
    weekends: true //Para que muestre lo findes
  };

  allOrders: PurchaseOrderResponse[] = []
  detailsForDay: ReportPurchaseOrderDays[] = []
  detailsForWeek: ReportPurchaseOrderDatesWeeks[] = []
  popupVisible = false;
  popupEvents: any[] = [];
  productId: number;
  startDate: any;
  endDate: any;
  showModalOrdes = false;
  productName = "";

  constructor(
    private toastService: ToastrService,
    private purchaseOrderService: PurchaseOrderService) { }

  ngOnInit(): void {
    
  }

  mappingOrderToCalendar(){
    this.filterOrders = this.detailsForDay.map((detail) => {
      return {
        title: detail.productName + ": " + detail.totalQuantity,
        startDate: this.formatDate(detail.deliveryDate).toLocaleDateString('en-CA'),
        // orderId: oc.id,
        extendedProps: detail
      }
    });

    this.calendarOptions.events = this.filterOrders.map(event => ({
        title: event.title,
        start: event.startDate,
        allDay: true,
        extendedProps: event.extendedProps
      }));
  }

  formatDate(date: any): Date {
    return new Date(date);
  }

  updateDate(info: any){
    const orderPuchase = info.event.extendedProps;
    console.log(`Evento movido a: ${info.event.start}`);
    console.log(`Evento movido a:`, orderPuchase);
  }

  // Genera las semanas en función de las fechas visibles
  generateWeeks(start: Date, end: Date) {
    const weeks: { start: Date; end: Date; label: string }[] = [];
    this.getReportForDays(start, new Date(end.getTime() - 1000));
    this.getReportForWeeks(start, new Date(end.getTime() - 1000));
    
    let current = this.startOfWeek(new Date(start)); // domingo
    const last = this.endOfWeek(new Date(end));     // sábado
    
    while (current <= last) {
      const weekStart = new Date(current);
      const weekEnd = this.endOfWeek(new Date(current));

      weeks.push({
        start: weekStart,
        end: weekEnd,
        label: `Semana ${this.getWeekNumber(weekStart)}`
      });

      current.setDate(current.getDate() + 7); // avanzar a la siguiente semana
    }

    this.weeksData = weeks.slice(0, -1);
  }

  // Primer día de la semana (domingo)
  startOfWeek(date: Date): Date {
    const d = new Date(date);
    const day = d.getDay(); // 0=domingo, 6=sábado
    d.setDate(d.getDate() - day); // retrocede hasta domingo
    d.setHours(0, 0, 0, 0);
    return d;
  }

  // Último día de la semana (sábado)
  endOfWeek(date: Date): Date {
    const d = this.startOfWeek(date);
    d.setDate(d.getDate() + 6); // avanza hasta sábado
    d.setHours(23, 59, 59, 999);
    return d;
  }

  // Número de semana del año (domingo como inicio)
  getWeekNumber(date: Date): number {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const yearStart = new Date(Date.UTC(date.getFullYear(), 0, 1));
    const days = Math.floor((d.getTime() - yearStart.getTime()) / 86400000);
    return Math.ceil((days + yearStart.getUTCDay() + 1) / 7);
  }

  getReportForDays(start: Date, end: Date){
    this.purchaseOrderService.getReportCalendarForDays(start, end).subscribe({
      next: (response: ResponseObject) => {
        this.detailsForDay = response.data;
        this.mappingOrderToCalendar();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se obtuvieron las ordenes del mes", "Error")
      }
    });
  }

  getReportForWeeks(start: Date, end: Date){
    this.purchaseOrderService.getReportCalendarForWeek(start, end).subscribe({
      next: (response: ResponseObject) => {
        this.detailsForWeek = response.data.slice(0, -1);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se obtuvieron las ordenes del mes", "Error")
      }
    });
  }

  openPopup(events: any[], startDate: Date, endDate: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.popupEvents = events;
    this.popupVisible = true;
  }

  closePopup() {
    this.popupVisible = false;
    this.popupEvents = [];
  }

  handleEventClick(info: any) {
    this.productId = info.event.extendedProps.productId;
    this.productName = info.event.extendedProps.productName;
    this.startDate = info.event.extendedProps.deliveryDate;
    this.endDate = info.event.extendedProps.deliveryDate;
    
    this.showModalOrdes = true;
  }

  openModalInfoOrderForDay(item: any, startDate: Date, endDate: Date){
    this.productId = item.productId;
    this.productName = item.productName;
    this.startDate = startDate;
    this.endDate = endDate;

    this.showModalOrdes = true;
  }

  openModalFromPopup(item: any){
    this.productId = item.productId;
    this.productName = item.productName;

    this.closePopup();
    this.showModalOrdes = true;
  }

  closeModalOrders(event) {
    this.showModalOrdes = false;
  }

  // Escucha global de la tecla Escape
  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    if (this.popupVisible) {
      this.closePopup();
    }
  }

}
